import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

const INITIAL_STATE = {
    beneficios: {},
    loading: false,
    erroImpressaoEco: null,
    loadingPdf: false,
    loadingModal: false,
    openDialog:false,
    contratoSelecionado:null,
    contatoInstituicao:null,
    tipoContratoSelecionado:'',
    openDialogDetailEmprestimo:false,
    mensagem: '',
    error: false,
    erro_descricao: '',
    contratosDeEmprestimoExcluidosEncerrados: [],
    contratosDeEmprestimoCartao: [],
    contratosDeEmprestimoAtivosSuspensos: [],
    descontosCartao: [],
};

const MSG_INFO_NAO_ENCONTRADAS = 'Informações sobre Consignados não encontradas.';
const MSG_SERVICO_INDISPONIVEL = `Serviço indisponível nesse momento. <p>Tente de novo mais tarde.</p>`;


export default (state = INITIAL_STATE, action) => {

    switch (action.type){

        case 'SET_DESCONTOS_CARTAO': 
            return {...state, descontosCartao: action.payload}

        case 'SET_CONTRATOS_EMPRESTIMO_ATIVOS_SUSPENSOS': 
            return {...state, contratosDeEmprestimoAtivosSuspensos: action.payload}

        case 'SET_CONTRATOS_EMPRESTIMO_CARTAO': 
            return {...state, contratosDeEmprestimoCartao: action.payload}

        case 'SET_CONTRATOS_EMPRESTIMO_EXCLUIDOS_ENCERRADOS': 
            return {...state, contratosDeEmprestimoExcluidosEncerrados: action.payload}

        case 'ECO_EXTRATO_INIT':
            return {...state, beneficios: {}, erroImpressaoEco: null, mensagem: ''}

        case 'ECO_EXTRATO_SOLICITADOS':
            return { ...state, loading: true, erroImpressaoEco: null, loadingPdf: true, mensagem: '', error: false };

        case 'ECO_EXTRATO_RECEBIDO':
            action.payload.listaExtratosConsignados = Array.isArray(action.payload.listaExtratosConsignados) ? 
                action.payload.listaExtratosConsignados[0] : 
                action.payload.listaExtratosConsignados;

            let nb = action.payload.listaExtratosConsignados.nb.replace(/\D+/g, "");

            return {
                ...state, 
                beneficios: {...state.beneficios, [nb]: action.payload.listaExtratosConsignados}, 
                loading: false, loadingPdf: false, mensagem: '', erroImpressaoEco: false
            };

        case 'ECO_ERRO_4xx_RECEBIDO':
                
                return {...state,
                    loading: false,
                    erroEco: 'erro',
                    loadingEco: false,
                    loadingPdf:false, 
                    mensagem: '',
                    error: true,
                    beneficios: {
                        ...state.beneficios,
                        [action.nb]: {
                            status: action.status,
                            notFound: (action.status === 404),
                            message: action.status === 404 ? (MSG_INFO_NAO_ENCONTRADAS) : (action.httpCode === 412 ? MSG_SERVICO_INDISPONIVEL : MSG_ERRO_SERVIDOR),
                            erro_descricao: action.status === 404 ? '' : (action.httpCode === 412 ? MSG_SERVICO_INDISPONIVEL : '')
                        }
                    },
                }

        case 'ECO_ERRO_5xx_RECEBIDO':
            return {
                ...state, 
                loadingPdf:false, 
                mensagem: '',
                error: true,
                loading: false,
                beneficios: {...state.beneficios, [action.nb]: {status: 500, message: MSG_ERRO_SERVIDOR}},
            };

        case 'ECO_IMPRESSAO_SOLICITADA':
            return {...state, loadingPdf: true, mensagem: '', erroImpressaoEco: false}
        
        case 'ECO_INFO_INSTITUICAO_SOLICITADA':
            return {...state, loadingModal: true, mensagem: '', erroImpressaoEco: false}

        case 'ECO_IMPRESSAO_ERRO':
            return {...state, loadingPdf: false, loadingModal: false, erroImpressaoEco: action.payload, mensagem: ''}

        case 'ECO_PDF_RECEBIDO':
            return {...state, loadingPdf: false, erroImpressaoEco: false, mensagem: 'sucesso'};
      
        case 'ECO_OPEN_DIALOG_DETAIL_EMPRESTIMO_CONTRATO':
            return { ...state, contatoInstituicao:action.payload.data, contratoSelecionado: action.payload.contrato,tipoContratoSelecionado:action.payload.tipoContratoSelecionado, openDialogDetailEmprestimo:false, loadingModal: false }
        
        case 'ECO_CLOSE_DIALOG_DETAIL_EMPRESTIMO_CONTRATO':
            return { ...state, openDialogDetailEmprestimo:false,tipoContratoSelecionado:'' }

        case 'ECO_VOLTAR':
            return { ...state, beneficio: undefined, mensagem: '', erroImpressaoEco: '' }

        case 'ECO_LIMPAR_MENSAGEM':
            return {...state, loadingPdf: false, loadingModal: false, erroImpressaoEco: false, mensagem: ''}   

        default:
            return state;
    }
}
